export default __webpack_public_path__ + "static/media/img_shouye_dezhou.887f1913.png";